module.exports = __webpack_public_path__ + "static/media/3.9f856a56.JPG";